/**
 * Persist Genius Options from /cart.js so PayTR-created Shopify orders
 * still get Seçenekler on the Admin order (Notlar + Ek bilgiler).
 */
(function geniusOrderOptionsSync() {
  if (window.__geniusOrderOptionsSync) return;
  window.__geniusOrderOptionsSync = true;

  var persistTimer = null;
  var lastPayloadKey = "";
  var lastCart = null;

  function shopDomain() {
    return (window.GeniusOptionsConfig && window.GeniusOptionsConfig.shop) || "";
  }

  function proxyUrl() {
    var base =
      (window.GeniusOptionsConfig && window.GeniusOptionsConfig.appProxyUrl) ||
      "/apps/genius-options";
    var shop = shopDomain();
    return shop ? base + "?shop=" + encodeURIComponent(shop) : base;
  }

  function labelFromProperties(properties) {
    if (!properties) return "";
    var preferred =
      properties["Yapılandırma"] ||
      properties.Configuration ||
      properties["Seçenekler"] ||
      properties.Options;
    if (preferred != null && String(preferred).trim()) return String(preferred).trim();
    if (properties._genius_options) {
      return String(properties._genius_options).replace(/\s*\|\|\s*/g, " | ").trim();
    }
    var parts = [];
    Object.keys(properties).forEach(function (key) {
      if (!key || key.charAt(0) === "_") return;
      var val = String(properties[key] || "").trim();
      if (val) parts.push(key + ": " + val);
    });
    return parts.join("; ");
  }

  function visibleProperties(properties) {
    var out = {};
    if (!properties) return out;
    Object.keys(properties).forEach(function (key) {
      if (!key || key.charAt(0) === "_") return;
      var val = String(properties[key] || "").trim();
      if (val) out[key] = val;
    });
    return out;
  }

  function itemsFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    var items = [];
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var summary = labelFromProperties(props);
      if (!summary) return;
      var extra = parseFloat(props._genius_options_price || 0) || 0;
      var unit = (Number(item.price) || 0) / 100 + extra;
      items.push({
        variantId: item.variant_id,
        productTitle: item.product_title || item.title || "Ürün",
        sku: item.sku || "",
        quantity: item.quantity || 1,
        optionsSummary: summary,
        optionsPrice: extra,
        expectedUnitPrice: unit,
        properties: visibleProperties(props),
      });
    });
    return items;
  }

  function persistCart(cart) {
    var shop = shopDomain();
    var token = cart && cart.token ? String(cart.token).replace(/\?.*$/, "") : "";
    var items = itemsFromCart(cart);
    if (!shop || !token || !items.length) return;
    var payload = { cartToken: token, items: items };
    var key = token + ":" + JSON.stringify(items);
    if (key === lastPayloadKey) return;
    lastPayloadKey = key;
    lastCart = cart;
    fetch(proxyUrl(), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify({ action: "save_cart_options", data: payload }),
    }).catch(function (err) {
      console.warn("[GeniusOptions] save_cart_options failed:", err);
      lastPayloadKey = "";
    });
  }

  function persistFromCartJs() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (cart) persistCart(cart);
      })
      .catch(function () {});
  }

  function schedulePersist() {
    if (persistTimer) clearTimeout(persistTimer);
    persistTimer = setTimeout(persistFromCartJs, 400);
  }

  function formatBasketName(title, properties) {
    var opts = labelFromProperties(properties);
    var base = String(title || "").trim();
    if (!opts) return base;
    var combined = base + " — " + opts;
    return combined.length > 200 ? combined.slice(0, 197) + "..." : combined;
  }

  function patchUserBasket(rawBasket) {
    if (!lastCart || !lastCart.items || !lastCart.items.length) return rawBasket;
    var basket = rawBasket;
    var parsed = rawBasket;
    var wasString = typeof rawBasket === "string";
    try {
      if (wasString) parsed = JSON.parse(rawBasket);
    } catch (e) {
      return rawBasket;
    }
    if (!Array.isArray(parsed)) return rawBasket;
    var next = parsed.map(function (row) {
      if (!Array.isArray(row) || !row.length) return row;
      var name = String(row[0] || "");
      var match = lastCart.items.find(function (item) {
        var title = String(item.product_title || item.title || "");
        return title && (name === title || name.indexOf(title) === 0);
      });
      if (!match) return row;
      var patched = row.slice();
      patched[0] = formatBasketName(match.product_title || match.title, match.properties);
      return patched;
    });
    return wasString ? JSON.stringify(next) : next;
  }

  function patchPaytrBody(body) {
    if (!body) return body;
    if (typeof body === "string") {
      if (body.indexOf("user_basket") === -1) return body;
      try {
        if (body.trim().charAt(0) === "{") {
          var json = JSON.parse(body);
          if (json.user_basket) json.user_basket = patchUserBasket(json.user_basket);
          return JSON.stringify(json);
        }
      } catch (e) {
        return body;
      }
      return body.replace(/user_basket=([^&]*)/i, function (full, encoded) {
        try {
          var decoded = decodeURIComponent(encoded.replace(/\+/g, " "));
          var patched = patchUserBasket(decoded);
          return "user_basket=" + encodeURIComponent(typeof patched === "string" ? patched : JSON.stringify(patched));
        } catch (err) {
          return full;
        }
      });
    }
    if (typeof FormData !== "undefined" && body instanceof FormData && body.has("user_basket")) {
      body.set("user_basket", patchUserBasket(body.get("user_basket")));
    }
    return body;
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function () {
    var args = arguments;
    var url = args[0];
    var init = args.length > 1 ? args[1] : undefined;
    var urlString = typeof url === "string" ? url : (url && url.url) || String(url || "");

    if (urlString.indexOf("/apps/genius-options") !== -1) {
      return originalFetch.apply(window, args);
    }

    if (init && init.body && /paytr/i.test(urlString)) {
      persistFromCartJs();
      init = Object.assign({}, init, { body: patchPaytrBody(init.body) });
      args = [url, init];
    }

    return originalFetch.apply(window, args).then(function (response) {
      if (
        response &&
        response.ok &&
        /\/cart\/(add|update|change|clear)/.test(urlString)
      ) {
        schedulePersist();
      }
      return response;
    });
  };

  document.addEventListener(
    "click",
    function (event) {
      var el = event.target && event.target.closest
        ? event.target.closest("button, a, [data-paytr], .paytr-button, #paytr")
        : null;
      if (!el) return;
      var haystack = (
        (el.getAttribute("href") || "") +
        " " +
        (el.id || "") +
        " " +
        (el.className || "") +
        " " +
        (el.name || "") +
        " " +
        (el.textContent || "")
      ).toLowerCase();
      if (haystack.indexOf("paytr") !== -1 || haystack.indexOf("güvenli ödeme") !== -1 || haystack.indexOf("guvenli odeme") !== -1) {
        persistFromCartJs();
      }
    },
    true
  );

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") persistFromCartJs();
  });
  window.addEventListener("pagehide", persistFromCartJs);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedulePersist);
  } else {
    schedulePersist();
  }

  window.GeniusOrderOptionsSync = {
    persist: persistFromCartJs,
    persistCart: persistCart,
  };
})();
